import { render, staticRenderFns } from "./printBagNumber.vue?vue&type=template&id=2efaf23c&scoped=true"
import script from "./printBagNumber.vue?vue&type=script&lang=js"
export * from "./printBagNumber.vue?vue&type=script&lang=js"
import style0 from "./printBagNumber.vue?vue&type=style&index=0&id=2efaf23c&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2efaf23c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre预发布-anjun-express-web-management/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2efaf23c')) {
      api.createRecord('2efaf23c', component.options)
    } else {
      api.reload('2efaf23c', component.options)
    }
    module.hot.accept("./printBagNumber.vue?vue&type=template&id=2efaf23c&scoped=true", function () {
      api.rerender('2efaf23c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/automaticSortings/ScanBagging/printBagNumber.vue"
export default component.exports